import type {TextFileDocument,TextFileEncoding,TextFileSaveResult,TextFileUpdate} from '@reados/contracts';
import {request} from './api';
export function getTextDocument(source:{fileId?:string;path?:string;contentRevision?:string},encoding?:TextFileEncoding,signal?:AbortSignal):Promise<TextFileDocument>{
 const query=new URLSearchParams();if(encoding)query.set('encoding',encoding);
 if(source.contentRevision)query.set('contentRevision',source.contentRevision);
 if(source.fileId)return request(`/files/${encodeURIComponent(source.fileId)}/text${query.size?'?'+query:''}`,{cache:'no-store',signal});
 if(source.path)query.set('path',source.path);
 return request(`/artifacts/text?${query}`,{cache:'no-store',signal});
}
export function saveTextDocument(fileId:string,update:TextFileUpdate):Promise<TextFileSaveResult>{return request(`/files/${encodeURIComponent(fileId)}/text`,{method:'PUT',body:JSON.stringify(update)});}
